// extracted by mini-css-extract-plugin
module.exports = {"AdSlot":"uh_a vh_a vh_j vh_q"};